// src/components/CalendlyButton.jsx
const CalendlyButton = ({ label = 'AGENDAR REUNIÃO' }) => {
    const openCalendly = () => {
      window.open("https://calendly.com/marino-signorini/45min", "_blank");
    };
  
    return (
      <div className="d-flex justify-content-center align-items-center">
        <button
          className="btn border-0 mb-3 px-5 py-3 mt-3 fw-bold"
          style={{
            backgroundColor: "#ECA600",
            letterSpacing: "1.8px",
            borderRadius: "50px",
            fontSize: "1.1rem",
            color: "black",
            transition: "all 0.3s ease",
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = "#f0b000";
            e.target.style.color = "#fff";
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = "#ECA600";
            e.target.style.color = "black";
          }}
          onClick={openCalendly}
        >
          {label}
        </button>
      </div>
    );
  };
  
  export default CalendlyButton;
  

